// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__34s5b","small":"styles_small__gFrQC","submitBtn":"styles_submitBtn__HONne"};